<div>
  <section>
    <div class="row mx-0 mb-2">
      <div class="col-10 px-0">
        <h3>
          Encounter Types
        </h3>
      </div>
    </div>

    <div class="mb-3">
      <p>
        Encounter data shared from your EHR is used to determine patient care ownership and eligibility
        for your 340B claim certifications. We need to ensure only encounter types that prove patient
        care ownership are flagged ELIGIBLE. Encounter types that do not prove patient care ownership
        should be flagged INELIGIBLE. Encounter types flagged NEW should be updated as soon as possible.
      </p>
      <p>
        <strong>
          If an encounter type is marked as <span class="eligibility-status eligible">eligible</span>, then encounters for this type will be used to satisfy patient care ownership.
        </strong>
      </p>
      <p>
        <strong>
          If an encounter type is <span class="eligibility-status new">new</span> or marked <span class="eligibility-status ineligible">ineligible</span>, encounters for this type will not be used to satisfy patient care ownership.
        </strong>
      </p>
    </div>

    <div class="container-fluid p-2 border rounded bg-light mb-4">
      <h5>New Encounter Types</h5>
      <p><em>NOTE: Data from encounter types in this list will not be used to capture claims until review is completed.</em></p>

      <app-encounter-type-eligibility-summary-table
        [label]="'new encounter types'"
        [paging]="newPaging"
        [loading]="newLoading"
        [encounterTypeEligibilitySummaries]="newEncounterTypeEligibilitySummaries"
        (pageSizeChange)="onNewPageSizeChange($event)"
        (pageChange)="onNewPageChange($event)" />
    </div>

    <div class="container-fluid p-2 border rounded bg-light mb-2">
      <h5>Current Encounter Types</h5>
      <p><em>Are encounter types missing? If yes please reach out to your NuvemRx contact to revisit your organization's data feed.</em></p>

      <form>
        <div class="row align-items-end">

          <div class="col-3">
            <div class="mb-3">
              <label><strong>Eligibility Status:</strong></label>
              <ng-select
                class="w-100"
                bindValue="value"
                bindLabel="display"
                name="eligibilityStatus"
                placeholder="Filter by Status"
                [multiple]="true"
                [items]="eligibilityStatusFilterOptions"
                (remove)="onFilterChange()"
                (change)="onFilterChange()"
                [(ngModel)]="filters.eligibilityStatuses" />
            </div>
          </div>

          <div class="col-3">
            <div class="mb-3">
              <label><strong>Encounter Types:</strong></label>
              <ng-select
                class="w-100"
                name="encounterTypes"
                placeholder="Filter by Encounter Type"
                [multiple]="true"
                [items]="encounterTypeFilterOptions"
                (remove)="onFilterChange()"
                (change)="onFilterChange()"
                [(ngModel)]="filters.encounterTypes" />
            </div>
          </div>

          <div class="col-auto mb-3">
            <button type="button" class="btn btn-info mt-0 clear-button" (click)="onResetFiltersClick()">Clear Filters</button>
          </div>

        </div>
      </form>

      <app-encounter-type-eligibility-summary-table
        [label]="'encounter types'"
        [paging]="paging"
        [loading]="loading"
        [encounterTypeEligibilitySummaries]="encounterTypeEligibilitySummaries"
        (pageSizeChange)="onPageSizeChange($event)"
        (pageChange)="onPageChange($event)" />
    </div>

  </section>
</div>
